import React from "react";
import netflixlogo from "../assets/netflix-logo.png";
import userlogo from "../assets/usericon04.png";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../utils/firebase";
import { useDispatch, useSelector } from "react-redux";
import { BROWSE, GPT_SEARCH } from "../utils/constants";
import { updateNavBtnText } from "../store/appSlice";
import { clearSearchResults } from "../store/searchResSlice";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.app.user);
  const navBtnText = useSelector((state) => state.app.navBtnText);

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        dispatch(updateNavBtnText(GPT_SEARCH));
        dispatch(clearSearchResults());
        navigate("/");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleNavigateBtn = (e) => {
    const curr_value = e.target.innerText;
    if (curr_value === BROWSE) {
      dispatch(updateNavBtnText(GPT_SEARCH));
      navigate("/browse");
    } else if (curr_value === GPT_SEARCH) {
      dispatch(updateNavBtnText(BROWSE));
      navigate("/search");
    }
  };
  return (
    <div className="absolute h-fit bg-gradient-to-b from-black inset-0 z-10 flex justify-between">
      <img className="p-4 w-32 md:w-40 lg:w-52" src={netflixlogo} alt="logo" />
      {user && (
        <div className="m-1 p-1 flex mt-5 text-white lg:mt-7">
          <button
            className="w-20 h-7 mx-2 font-bold text-sm md:w-24 lg:text-base"
            onClick={(event) => handleNavigateBtn(event)}
          >
            {navBtnText}
          </button>
          <img className="w-7 h-7" src={userlogo} alt="logo" />
          <button
            className="w-10 h-7 mx-2 font-bold text-sm lg:text-base lg:mx-6"
            onClick={() => handleSignOut()}
          >
            SignOut
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
